<template>
	<div>
		<div
		v-for="(item, index) in goods"
		:key="index"
		class="goodsList"
		>
			<div>
				<div @click="toGoodsInfo(item.id)" style="cursor: pointer;">
					<el-image :src='item.img[0]' class="goodsImage" fit="fit">
						    <template #error>
								<div class="errorFonts">
									<div>暂无图片</div>
								</div>
                            </template>
					</el-image>
					<div class="desc">{{item.number}}/{{item.name}}</div>
					<div class="extdata">{{'年度:'+item.year+'产品规格:'+item.spec}}</div>
					<div v-if="$global.showProductPrice">
						<div class="price" v-if="item.specs.length>0">{{'单价:￥'+item.specs[0].price}}</div>
						<div class="price" v-else>{{'单价:￥'+item.price}}</div>
					</div>
					
				</div>
				<div class="addCar" @click="openDialog(item.id)" style="cursor: pointer;background:#f3f3f3" v-if="item.specs.length>1">
					<i class="iconfont">&#xe63b;</i>
					<div>加入购物车</div>
				</div>
				<div class="addCar" v-else>
					<div>
						<div v-if='$global.buyType==0' style="height:24px"></div>
						<InNumber
							:datainfo="item.specs[0]"
							:dataKey="'count'"
							v-if="$global.buyType!=2"
							:miniType='true'
							:suffix="$global.pack"
							@changeEnd="changeEnd($event,item,item.specs[0],'count')"
						></InNumber>
						<div v-if='$global.buyType==0' style="height:10px"></div>
						<InNumber
							:datainfo="item.specs[0]"
							:dataKey="'num'"
							v-if="$global.buyType!=1"
							:miniType='true'
							:suffix="$global.unit"
							@changeEnd="changeEnd($event,item,item.specs[0],'num')"
						></InNumber>
					</div>
				</div>
			</div>
		</div>
		<div style="clear:both;margin-top: 15px;text-align: right;">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
			 :page-sizes="[20, 50]" :page-size="sizeNumber" layout="total, sizes, prev, pager, next, jumper" :total="totalNumber" :pager-count="5">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	export default {
		name: "goods",
		props: {
			goods: {
				type: Array,
				default: function() {
					return [];
				}
			},
			currentPage:{
				type:Number,
				default:1,
			},
			sizeNumber:{
				type:Number,
				default:100,
			},
			totalNumber:{
				type:Number,
				default:100,
			},
			buyType:{
				type:Number,
				default:1,
			}
		},
		data() {
			return {
				curIndex:-1,
			}
		},

		methods: {
			openDialog(id){
				this.$emit("openDialog",id);
			},
			toGoodsInfo(val) {
            	// this.$router.push({
                // 	path: "/goodsInfo",
                // 	name: "商品详情",
                // 	query: {
                //     	id: val,
                // 	},
            	// });
			},
			changeEnd(e,dd,sp,val){
				sp[val] = e;
				this.$emit("updateNum",dd,sp.id);
			},
			handleSizeChange(val) {
				this.$emit("handleSizeChange",val);
			},
			handleCurrentChange(val) {
				this.$emit("handleCurrentChange",val);
			},
		},
	};
</script>

<style lang="scss" scoped>
	.goodsList {
			float: left;
			margin-right: 0.5%;
			margin-bottom: 10px;
			position: relative;
			width: 200px;
			height: 300px;
			padding: 5px;
		}

		.goodsImage {
			width: 160px;
			height: 160px;
			padding: 8px 20px 2px 20px;
		}

		.desc {
			font-size: 14px;
			line-height: 20px;
			height: 20px;
			text-align: center;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		.extdata{
			font-size: 14px;
			line-height: 20px;
			height: 20px;
			text-align: center;
			overflow: hidden;
		}
		.price {
			font-weight: bold;
			color: #e60012;
			font-size: 14px;
			line-height: 20px;
			height: 20px;
			text-align: center;
		}

		.addCar {
			width: 100%;
			height: 40px;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 14px;
			border-radius: 3px;
			.iconfont {
				font-size: 14px;
				color: #1f8fff;
				margin-right: 5px;
			}
		}
</style>
